export const queryKeys = {
  CONTRACT_VARIATION_GROUP: 'CONTRACT_VARIATION_GROUP',
  CONTRACT_VARIATION_GROUP_ID: 'CONTRACT_VARIATION_GROUP_ID',
  TERM_DISCOUNT: 'TERM_DISCOUNT',
  TERM_DISCOUNT_AVAILABLE: 'TERM_DISCOUNT_AVAILABLE'
};
